import React, { FC, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../hooks/useStateContext';
import { LoadingPage } from '../LoadingPage/LoadingPage';

export const LandingPage: FC = () => {
  const {
    user: { views },
  } = useStateContext();
  const navigate = useNavigate();

  const envType = useMemo(() => {
    return process.env.NODE_ENV;
  }, []);

  useEffect(() => {
    navigate('groups', {
      replace: true,
    });
  }, [navigate, views]);

  return (
    <>
      {/*<Header
        changePage={() => {
          console.log();
        }}
      />*/}
      <LoadingPage />;
    </>
  );
};
